import React from 'react';
import { LandingPageWrapper } from '@/components/landing-pages/landing-page-wrapper';
import { LoyaltyTermsModalWrapper } from '@/components/loyalty/loyalty-terms-modal-wrapper';
import { useHasLoyaltyProgram } from '@/hooks/use-has-loyalty-program';
import { useLoyaltyTermsPrompt } from '@/hooks/use-loyalty-terms-prompt';
import { useSupplierDynamicConfigValue } from '@/hooks/use-dynamic-config-value';

export const AppOverlays: React.FC = () => {
  const hasLoyaltyProgram = useHasLoyaltyProgram();
  const landingPageEnabled = useSupplierDynamicConfigValue(
    'landing_page_enabled',
  );

  const { isBlocking } = useLoyaltyTermsPrompt(hasLoyaltyProgram);

  return (
    <>
      {hasLoyaltyProgram ? <LoyaltyTermsModalWrapper /> : null}
      {landingPageEnabled ? (
        // Loyalty terms take precedence over landing pages
        <LandingPageWrapper canShow={!isBlocking} />
      ) : null}
    </>
  );
};
